document.addEventListener('DOMContentLoaded', async () => {
  const localZip = localStorage.getItem("userZipCode");
  if (localZip && localZip !== 'null') {
      console.log("zip (cache):", localZip)
      const matchedLocationId = await mapPostalCodeToLocationId(localZip);
      if (matchedLocationId) {
        selectLocationSafe(matchedLocationId);
        filterVariantsByLocation(matchedLocationId);
      }
  }

  // Siempre se recalcula en segundo plano; si la ubicación real difiere
  // de la cacheada, el almacén se actualiza en cuanto se resuelva.
  requestZipFromGeolocation();
});

// Almacén de respaldo cuando no es posible determinar el código postal del
// cliente (dispositivo sin soporte de geolocalización, permiso rechazado,
// o fallo de todas las APIs de resolución por IP/reverse-geocoding).
const FALLBACK_LOCATION_ID = "70672580862";

function applyFallbackLocation(reason) {
    console.warn(`⚠️ No se pudo determinar el código postal (${reason}). Usando almacén de respaldo: ${FALLBACK_LOCATION_ID}`);
    selectLocationSafe(FALLBACK_LOCATION_ID);
    filterVariantsByLocation(FALLBACK_LOCATION_ID);
}

function requestZipFromGeolocation() {
    if (!navigator.geolocation) {
        console.error("❌ Geolocalización no soportada por el navegador.");
        fetchZipFromIP();
        return;
    }

    navigator.geolocation.getCurrentPosition(
        (position) => {
            const { latitude, longitude } = position.coords;
            console.log(latitude, longitude);

            // fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=es`)
            fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=&longitude=${longitude}&localityLanguage=es`)
            .then(response => response.json())
            .then(data => {
                console.log("Código postal (BigDataCloud):", data.postcode);
                console.log("Ciudad:", data.city);
                console.log("País:", data.countryName);

                if (data.postcode) {
                    resolveZipToLocation(data.postcode);
                } else {
                    console.warn("⚠️ BigDataCloud no devolvió código postal, se intenta con Nominatim...");
                    fetchPostalCodeFromNominatim(latitude, longitude);
                }
            })
            .catch(error => {
                console.error('Error al hacer fetch a BigDataCloud:', error);
                fetchPostalCodeFromNominatim(latitude, longitude);
            });
        },
        (error) => {
            console.error('❌ Error al obtener la ubicación del navegador:', error);
            console.warn("⚠️ Se usará la IP del usuario para aproximar el código postal.");
            fetchZipFromIP();
        },
        {
            enableHighAccuracy: true,
            maximumAge: 0,
            timeout: 10000
        }
    );
}

function fetchZipFromIP() {
    fetch('https://ipapi.co/json/')
    .then(response => response.json())
    .then(data => {
        console.log("Código postal (IP - ipapi.co):", data.postal);
        console.log("Ciudad (IP):", data.city);

        if (data.postal) {
            resolveZipToLocation(data.postal);
        } else {
            console.warn("⚠️ ipapi.co no devolvió código postal, se intenta con ipwho.is...");
            fetchZipFromIPFallback();
        }
    })
    .catch(error => {
        console.error('Error al hacer fetch a ipapi.co:', error);
        fetchZipFromIPFallback();
    });
}

function fetchZipFromIPFallback() {
    fetch('https://ipwho.is/')
    .then(response => response.json())
    .then(data => {
        const postalCode = data?.postal;
        console.log("Código postal (IP - ipwho.is):", postalCode);

        if (postalCode) {
            resolveZipToLocation(postalCode);
        } else {
            applyFallbackLocation("ipwho.is no devolvió código postal");
        }
    })
    .catch(error => {
        console.error('Error al hacer fetch a ipwho.is:', error);
        applyFallbackLocation("fetch a ipwho.is falló");
    });
}

function fetchPostalCodeFromNominatim(latitude, longitude) {
    fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}&addressdetails=1&accept-language=es`)
    .then(response => response.json())
    .then(data => {
        const postalCode = data?.address?.postcode;
        console.log("Código postal (Nominatim):", postalCode);

        if (postalCode) {
            resolveZipToLocation(postalCode);
        } else {
            applyFallbackLocation("Nominatim no devolvió código postal");
        }
    })
    .catch(error => {
        console.error('Error al hacer fetch a Nominatim:', error);
        applyFallbackLocation("fetch a Nominatim falló");
    });
}

async function resolveZipToLocation(postalCode) {
    const matchedLocationId = await mapPostalCodeToLocationId(postalCode);
    if (!matchedLocationId) {
        applyFallbackLocation(`código postal obtenido (${postalCode}) no es válido`);
        return;
    }

    localStorage.setItem("userZipCode", postalCode);
    localStorage.setItem("zipFlag", false);
    selectLocationSafe(matchedLocationId);
    filterVariantsByLocation(matchedLocationId);
}

// Bloquea la selección de combinaciones de variante sin stock en el almacén
// resuelto para el cliente, considerando la combinación COMPLETA de opciones
// (no solo si algún variant comparte un valor suelto).
//
// En vez de reimplementar el matching combinatorio, reutiliza el mecanismo
// que theme.dev.js ya trae para esto: la clase SelloutVariants ("Sellout
// Precrime"), instanciada como `sellout` dentro de cada <product-form> y
// re-ejecutada automáticamente en cada cambio de opción vía
// ProductForm.pushState() -> this.sellout.update(). Esa clase ya resuelve
// "¿existe una variante con esta combinación exacta, y está disponible?"
// usando product-form.productJSON (el JSON estándar de Shopify). Aquí solo
// sobreescribimos variant.available en ese mismo objeto con la disponibilidad
// por ubicación (leída de stockData) y disparamos sellout.update() de nuevo;
// el resto (clases sold-out/unavailable, y su reaplicación en cada cambio
// posterior) sigue el camino nativo del theme sin duplicarlo.
//
// Encima de eso, agregamos bloqueo real (disabled / aria-disabled) porque el
// theme por defecto solo marca visualmente sold-out/unavailable, pero sigue
// dejando seleccionar la combinación (el add-to-cart es lo que se deshabilita).
//
// Usa el atributo propio data-loc-position (NO [data-option-value]/
// [data-option-position]): theme.dev.js (ProductForm.updateLegend) ya usa esos
// dos para reescribir el innerHTML del value seleccionado; reutilizarlos
// rompía los swatches (ver incidente 2026-09-01).
let lastResolvedLocationId = null;

// El metafield locationInventory.info (namespace de la app Kark) NO es legible
// desde Liquid (es un metafield reservado de la app: el toggle "Acceso a la
// API Storefront" del admin no expone nada a plantillas de tema, confirmado
// en vivo probando ambos caminos). Pero SÍ es legible vía la API GraphQL
// Storefront con ese mismo toggle activado, así que la cantidad real por
// ubicación se obtiene con un fetch aparte en vez de venir ya en el JSON que
// renderiza product-variant-options.liquid (ese JSON solo trae options/
// available, que sí son de lectura nativa en Liquid).
const STOREFRONT_ACCESS_TOKEN = 'f8272b6ee3c7cd48fd28b5e1f60782d5';
const STOREFRONT_API_VERSION = '2026-01';

const locationStockFetchCache = {};

function fetchLocationStockForHandle(handle) {
    if (locationStockFetchCache[handle]) return locationStockFetchCache[handle];

    const shopDomain = window.Shopify?.shop || 'godsbeardcult.myshopify.com';
    const query = `query ProductLocationStock($handle: String!) {
        product(handle: $handle) {
            variants(first: 100) {
                nodes {
                    id
                    metafield(namespace: "locationInventory", key: "info") { value }
                }
            }
        }
    }`;

    const promise = fetch(`https://${shopDomain}/api/${STOREFRONT_API_VERSION}/graphql.json`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({ query, variables: { handle } }),
    })
        .then((response) => response.json())
        .then(({ data, errors }) => {
            if (errors) {
                console.error(`[LOC-STOCK] Storefront API devolvió errores para "${handle}":`, errors);
                return {};
            }

            const perVariantLocations = {};
            (data?.product?.variants?.nodes || []).forEach((node) => {
                const variantId = node.id.split('/').pop();
                const rawValue = node.metafield?.value;
                if (!rawValue) return;

                try {
                    const parsed = JSON.parse(rawValue);
                    const locations = {};
                    (parsed.invLoc || []).forEach((entry) => {
                        locations[entry.loc.id] = entry.qty;
                    });
                    perVariantLocations[variantId] = { locations, policy: parsed.policy, mgt: parsed.mgt };
                } catch (error) {
                    console.error(`[LOC-STOCK] No se pudo parsear el metafield de la variante ${variantId}:`, error);
                }
            });

            console.log(`[LOC-STOCK] Storefront API: stock por ubicación obtenido para "${handle}"`, perVariantLocations);
            return perVariantLocations;
        })
        .catch((error) => {
            console.error(`[LOC-STOCK] Falló el fetch a la Storefront API para "${handle}":`, error);
            return {};
        });

    locationStockFetchCache[handle] = promise;
    return promise;
}

// Completa stockMap (options/available, ya correctos vía Liquid) con la
// cantidad real por ubicación obtenida de la Storefront API.
async function enrichStockMapWithRealLocations(stockMap) {
    const handles = new Set();
    document.querySelectorAll('script[data-variant-location-stock][data-product-handle]').forEach((script) => {
        const handle = script.getAttribute('data-product-handle');
        if (handle) handles.add(handle);
    });

    for (const handle of handles) {
        const perVariantLocations = await fetchLocationStockForHandle(handle);
        Object.keys(perVariantLocations).forEach((variantId) => {
            if (!stockMap[variantId]) return;
            stockMap[variantId].locations = perVariantLocations[variantId].locations;
            stockMap[variantId].policy = perVariantLocations[variantId].policy;
            stockMap[variantId].mgt = perVariantLocations[variantId].mgt;
        });
    }

    return stockMap;
}

function buildLocationStockMap() {
    const map = {};
    const scripts = document.querySelectorAll('script[data-variant-location-stock]');
    console.log(`[LOC-STOCK] scripts data-variant-location-stock encontrados: ${scripts.length}`);

    scripts.forEach((script) => {
        try {
            const parsed = JSON.parse(script.textContent);
            console.log(`[LOC-STOCK] stockData leído (producto ${script.getAttribute('data-product-id')}):`, parsed);
            Object.assign(map, parsed);
        } catch (error) {
            console.error("❌ No se pudo parsear el stock por ubicación:", error);
        }
    });

    console.log(`[LOC-STOCK] stockMap combinado (${Object.keys(map).length} variantes):`, map);
    return map;
}

function isVariantAvailableAtLocation(stockInfo, locationId) {
    const locations = stockInfo.locations || {};
    const hasLocationData = Object.keys(locations).length > 0;

    let available;
    let reason;

    if (!hasLocationData) {
        // Sin datos de la app para esta variante: nos quedamos con la
        // disponibilidad global de Shopify como respaldo.
        available = !!stockInfo.available;
        reason = `sin datos de ubicación, fallback a available=${stockInfo.available}`;
    } else if (stockInfo.mgt !== 'shopify' || stockInfo.policy === 'CONTINUE') {
        // No se rastrea inventario o se permite vender sin stock.
        available = true;
        reason = `mgt=${stockInfo.mgt} / policy=${stockInfo.policy} → siempre disponible`;
    } else {
        const qty = locations[locationId] || 0;
        available = qty > 0;
        reason = `qty en locationId ${locationId} = ${qty}`;
    }

    console.log(`[LOC-STOCK] disponibilidad @ location ${locationId}: ${available} (${reason})`, stockInfo);
    return available;
}

// Traduce las clases sold-out/unavailable que SelloutVariants ya calculó
// (combinación completa) en bloqueo real de selección.
function applyHardDisableState(root) {
    let disabledCount = 0;
    let blockedCount = 0;

    root.querySelectorAll('input[name^="options"]').forEach((input) => {
        const blocked = input.classList.contains('sold-out') || input.classList.contains('unavailable');
        input.disabled = blocked;
        if (blocked) {
            disabledCount++;
            console.log(`[LOC-STOCK] input deshabilitado: name="${input.name}" value="${input.value}"`);
        }
    });

    root.querySelectorAll('[data-popout-option]').forEach((anchor) => {
        const blocked = anchor.classList.contains('sold-out') || anchor.classList.contains('unavailable');
        anchor.setAttribute('aria-disabled', blocked ? 'true' : 'false');
        if (blocked) {
            blockedCount++;
            console.log(`[LOC-STOCK] opción de dropdown bloqueada: value="${anchor.getAttribute('data-value')}"`);
        }
    });

    console.log(`[LOC-STOCK] applyHardDisableState: ${disabledCount} radios/swatches deshabilitados, ${blockedCount} opciones de dropdown bloqueadas`);
}

// Si la opción actualmente seleccionada en alguna posición quedó bloqueada,
// selecciona automáticamente la primera alternativa disponible en esa misma
// posición mediante un click real (dispara toda la cadena nativa del theme:
// change -> pushState -> sellout.update() -> ...).
function reselectUnavailableOptions(root) {
    const positions = new Set();
    root.querySelectorAll('[data-loc-position]').forEach((el) => positions.add(el.getAttribute('data-loc-position')));

    positions.forEach((pos) => {
        const checkedRadio = root.querySelector(`input[name^="options"][data-index="option${pos}"]:checked`);
        if (checkedRadio && checkedRadio.disabled) {
            const nextRadio = root.querySelector(`input[name^="options"][data-index="option${pos}"]:not(:disabled)`);
            console.log(`[LOC-STOCK] posición ${pos}: selección actual "${checkedRadio.value}" quedó bloqueada, reseleccionando →`, nextRadio ? nextRadio.value : '(sin alternativa disponible)');
            if (nextRadio) nextRadio.click();
        }

        const activeAnchor = root.querySelector(
            `.select-popout__item[data-loc-position="${pos}"].is-active [data-popout-option]`
        );
        if (activeAnchor && activeAnchor.getAttribute('aria-disabled') === 'true') {
            const nextAnchor = root.querySelector(
                `.select-popout__item[data-loc-position="${pos}"] [data-popout-option]:not([aria-disabled="true"])`
            );
            console.log(`[LOC-STOCK] posición ${pos} (dropdown): selección actual "${activeAnchor.getAttribute('data-value')}" quedó bloqueada, reseleccionando →`, nextAnchor ? nextAnchor.getAttribute('data-value') : '(sin alternativa disponible)');
            if (nextAnchor) nextAnchor.click();
        }
    });
}

async function filterVariantsByLocation(locationId) {
    console.log(`[LOC-STOCK] filterVariantsByLocation() llamado con locationId =`, locationId);
    if (!locationId) {
        console.warn('[LOC-STOCK] locationId vacío, se aborta el filtrado.');
        return;
    }
    lastResolvedLocationId = locationId;

    let stockMap = buildLocationStockMap();
    if (Object.keys(stockMap).length === 0) {
        console.warn('[LOC-STOCK] stockMap vacío, no hay nada que filtrar.');
        return;
    }

    stockMap = await enrichStockMapWithRealLocations(stockMap);
    console.log('[LOC-STOCK] stockMap enriquecido con Storefront API:', stockMap);

    const productForms = document.querySelectorAll('product-form');
    console.log(`[LOC-STOCK] <product-form> encontrados en la página: ${productForms.length}`);

    productForms.forEach((productFormEl) => {
        const productJSON = productFormEl.productJSON;
        if (!productJSON || !productJSON.variants) {
            console.warn('[LOC-STOCK] <product-form> sin productJSON todavía (¿aún no se conecta el custom element?), se omite:', productFormEl);
            return;
        }

        console.log(`[LOC-STOCK] procesando producto "${productJSON.handle}" (${productJSON.variants.length} variantes)`);

        productJSON.variants.forEach((variant) => {
            const stockInfo = stockMap[variant.id];
            if (!stockInfo) {
                console.log(`[LOC-STOCK] variante ${variant.id} (${variant.title}) sin stockData, se conserva available=${variant.available}`);
                return;
            }
            const before = variant.available;
            variant.available = isVariantAvailableAtLocation(stockInfo, locationId);
            console.log(`[LOC-STOCK] variante ${variant.id} (${variant.title}): available ${before} → ${variant.available}`);
        });

        console.log('[LOC-STOCK] llamando sellout.update() para recalcular combinaciones', productFormEl.sellout);
        productFormEl.sellout?.update();
    });

    applyHardDisableState(document);
    reselectUnavailableOptions(document);
    console.log('[LOC-STOCK] filterVariantsByLocation() terminado');
}

// Reaplica el bloqueo tras cualquier cambio de opción (swatch/radio/dropdown).
// El setTimeout(0) difiere la ejecución a después del manejo síncrono nativo
// del evento 'change' (pushState -> sellout.update(), que ya deja las clases
// sold-out/unavailable listas usando el productJSON que mutamos arriba).
// Se usa fase de captura porque el <input type="hidden"> del dropdown dispara
// un 'change' sin bubbles (new Event("change")) en theme.dev.js.
document.addEventListener('change', (evt) => {
    if (!lastResolvedLocationId) return;
    if (!evt.target.matches('input[name^="options"], [data-popout-input]')) return;

    console.log(`[LOC-STOCK] 'change' detectado en`, evt.target, '→ recalculando bloqueo por ubicación', lastResolvedLocationId);

    setTimeout(() => {
        applyHardDisableState(document);
        reselectUnavailableOptions(document);
    }, 0);
}, true);

// Bloquea el click en las opciones del dropdown marcadas sold-out/unavailable
// por SelloutVariants (input:disabled ya bloquea nativamente radios/swatches,
// pero un <a> no tiene ese comportamiento nativo). Se registra una sola vez;
// evalúa las clases en el momento del click, no un estado cacheado.
document.addEventListener('click', (evt) => {
    const blockedAnchor = evt.target.closest('[data-popout-option].sold-out, [data-popout-option].unavailable');
    if (blockedAnchor) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
    }
}, true);

selectLocationSafe = (locationId, retries = 20) => {
    // ❌ Evitar ejecutar en checkout
    if (
      window.location.pathname.startsWith("/checkouts") ||
      document.body.classList.contains("template-checkout")
    ) {
      console.log("⚠️ No se ejecuta selectLocation en checkout");
      return;
    }

    // Evita re-setear si ya está seteada esta misma ubicación (no bloquea actualizaciones a otra distinta)
    if (this.currentLocationId === locationId) return;

    if (
      window.inventoryInfo &&
      window.inventoryInfo.api &&
      typeof window.inventoryInfo.api.selectLocation === "function"
    ) {
      try {
        window.inventoryInfo.api.selectLocation(locationId);
        this.currentLocationId = locationId;
        console.log(`✅ Location seteada: ${locationId}`);
      } catch (error) {
        console.error("❌ selectLocation lanzó un error:", error);
      }
    } else if (retries > 0) {
      setTimeout(() => {
        this.selectLocationSafe(locationId, retries - 1);
      }, 150);
    } else {
      console.error("❌ selectLocation nunca estuvo disponible");
    }
  };

let postalCodeDataPromise = null;

function loadPostalCodeData() {
    if (!postalCodeDataPromise) {
        if (!window.postalCodeLocationsUrl) {
            console.error("❌ window.postalCodeLocationsUrl no está definido.");
            postalCodeDataPromise = Promise.resolve({ default: null, ranges: [], exact: {} });
        } else {
            postalCodeDataPromise = fetch(window.postalCodeLocationsUrl)
                .then((response) => response.json())
                .catch((error) => {
                    console.error("❌ No se pudo cargar postal-code-locations.json:", error);
                    return { default: null, ranges: [], exact: {} };
                });
        }
    }
    return postalCodeDataPromise;
}

async function mapPostalCodeToLocationId(input) {
    const zipCode = String(input).trim().padStart(5, "0");
    if (!/^\d{5}$/.test(zipCode)) {
        console.warn("Código postal inválido.");
        return;
    }
    const zip = parseInt(zipCode, 10);

    const data = await loadPostalCodeData();

    if (data.exact && Object.prototype.hasOwnProperty.call(data.exact, zipCode)) {
        return data.exact[zipCode];
    }

    for (const range of data.ranges || []) {
        if (zip >= range.from && zip <= range.to) {
            return range.id;
        }
    }

    return data.default || "70672580862"; // fallback CDMX
}